import env from 'pages/MyAccount/utils/env';
import {
  flattenProducts,
  getSocialCartProducts,
  getSocialCartVariants,
} from '@fff-web/fff-cart';
import requestJson from './requestJson';
import request from './request';

export const getInviteData = (token) => {
  const headers = { Accept: 'application/vnd.fabfitfun.v1+json' };
  return requestJson(
    `${env.invitationApi}/invites/validate?token=${token}`,
    'PUT',
    headers
  );
};

export const getTeamId = (campaignId, campaignWindow) => {
  const headers = { Accept: '*' };
  return requestJson(
    `${env.aceApi}api/1/teams/campaigns/${campaignId}/windows/${campaignWindow}`,
    'GET',
    headers
  );
};

export const getInvitationsAndTeam = (campaignId, campaignWindow) =>
  request(
    `${env.aceApi}api/1/teams/members/campaigns/${campaignId}/windows/${campaignWindow}`,
    'GET'
  );

export const createTeamRequest = (campaignId, campaignWindow) => {
  const headers = { Accept: '*' };
  return requestJson(
    `${env.aceApi}api/1/teams/campaigns/${campaignId}/windows/${campaignWindow}`,
    'POST',
    headers
  );
};

export const getInvitesRemaining = (teamId) => {
  const headers = { Accept: '*' };
  return requestJson(
    `${env.invitationApi}/invites/users/self/active/count?teamId=${teamId}`,
    'GET',
    headers
  );
};

export const sendInviteRequest = (data) => {
  const headers = {
    Accept: 'application/vnd.fabfitfun.v1+json',
    'Content-Type': 'application/json',
  };
  const { metadata } = data;
  const payload = {
    ...data,
    metadata: metadata && JSON.stringify(metadata),
  };
  return requestJson(
    `${env.invitationApi}/invites/assign`,
    'PUT',
    headers,
    JSON.stringify(payload)
  );
};

export const getTeamCarts = async (teamId) => {
  const headers = { Accept: '*' };
  const requestUrl = `${env.aceApi}api/1/carts/teams/${teamId}`;
  const response = await requestJson(requestUrl, 'GET', headers);
  const {
    variantIdProductMap,
    variants: variantsUsers,
    userIds,
    products: productsWithVariants,
  } = response.data.items[0];
  const { products, variants } = flattenProducts(productsWithVariants);
  const cartVariants = getSocialCartVariants(variantsUsers, variants, products);
  const cartProducts = getSocialCartProducts(
    variantIdProductMap,
    variantsUsers
  );

  return { cartProducts, userIds, cartVariants, products, variants };
};

export const getTeamAvatars = (userIds) => {
  const requestUrl = `${env.avatarApi}/shop-users/avatars-resolver`;
  const data = JSON.stringify({
    shopUserIds: userIds,
    withoutImageSize: false,
  });
  return request(
    requestUrl,
    'POST',
    { 'Content-Type': 'application/json' },
    data
  );
};

export const reedemInviteAndJoinTeam = (token) => {
  const headers = {
    Accept: 'application/vnd.fabfitfun.v1+json',
    'Content-Type': 'application/json',
  };
  return request(
    `${env.registerApi}/1/social/invites/${token}/redeem`,
    'PUT',
    headers,
    '',
    false,
    false
  );
};
